<template>
  <CardModule title="Regras de Acesso">
    <v-row v-if="isCommomOrCourtesy">
      <v-col cols="12">
        <BaseTextField
          required
          label="Dias antes"
          placeholder="Ex: 3 dias antes"
          type="number"
          min="0"
          :rules="[rules.requiredZero]"
          v-model.number="$produtos_gerenciar.cadastro.regra_acesso.dias_antes"
        />
      </v-col>
      <v-col cols="12">
        <BaseTextField
          required
          label="Horas antes"
          placeholder="Ex: 10 horas antes"
          type="number"
          min="0"
          max="24"
          :rules="[rules.requiredZero]"
          v-model.number="$produtos_gerenciar.cadastro.regra_acesso.horas_antes"
        />
      </v-col>
      <v-col cols="12">
        <BaseTextField
          required
          label="Dias depois"
          placeholder="Ex: 5 dias depois"
          type="number"
          min="0"
          :rules="[rules.requiredZero]"
          v-model.number="$produtos_gerenciar.cadastro.regra_acesso.dias_depois"
        />
      </v-col>
      <v-col cols="12">
        <BaseTextField
          required
          label="Horas depois"
          placeholder="Ex: 10 horas depois"
          type="number"
          min="0"
          max="24"
          :rules="[rules.requiredZero]"
          v-model.number="
            $produtos_gerenciar.cadastro.regra_acesso.horas_depois
          "
        />
      </v-col>
      <v-col cols="12">
        <BaseTextField
          required
          label="Limite de uso"
          placeholder="Ex: 1"
          type="number"
          min="0"
          :rules="[rules.requiredZero]"
          v-model.number="$produtos_gerenciar.cadastro.regra_acesso.limite_uso"
        />
      </v-col>
      <v-col cols="12" v-if="isAdmin && storeHasElevenTicketsAccessInfo">
        <v-checkbox
          v-model="$produtos_gerenciar.cadastro.regra_acesso.valida_circus"
          label="Desativar integração na validação"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
          :messages="validateCircusMessage"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="12" v-if="hasCircusValidation">
        <BaseTextField
          required
          :label="'ID ElevenTickets Access'"
          placeholder="Informe o ID de acesso do ElevenTickets"
          :rules="hasCircusValidation ? [rules.required] : []"
          v-model="$produtos_gerenciar.cadastro.regra_acesso.idevento_circus"
        />
      </v-col>
    </v-row>
    <v-row v-if="isVoucherProduct">
      <v-col cols="12">
        <BaseTextField
          required
          label="Dias depois"
          placeholder="Ex: 3"
          type="number"
          min="0"
          :rules="[rules.requiredZero]"
          v-model.number="$produtos_gerenciar.cadastro.regra_acesso.dias_depois"
        />
      </v-col>
      <v-col cols="12">
        <BaseTextField
          required
          label="Limite de uso"
          placeholder="Ex: 1"
          type="number"
          min="0"
          :rules="[rules.requiredZero]"
          v-model.number="$produtos_gerenciar.cadastro.regra_acesso.limite_uso"
        />
      </v-col>
      <v-col cols="12" v-if="isAdmin && storeHasElevenTicketsAccessInfo">
        <v-checkbox
          v-model="$produtos_gerenciar.cadastro.regra_acesso.valida_circus"
          label="Desativar integração na validação"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
          :messages="validateCircusMessage"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="12" v-if="hasCircusValidation && isVoucherProduct">
        <BaseTextField
          required
          :label="'ID ElevenTickets Access'"
          placeholder="Informe o ID de acesso do ElevenTickets"
          :rules="hasCircusValidation ? [rules.required] : []"
          v-model="$produtos_gerenciar.cadastro.regra_acesso.idevento_circus"
        />
      </v-col>
    </v-row>
  </CardModule>
</template>

<script>
import mixins from "@/mixins";
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";

const { formRules } = mixins;

export default {
  name: "AccessRules",
  mixins: [formRules],
  components: {
    CardModule,
    BaseTextField,
  },
  data: () => ({
    validateCircusMessage:
      "ℹ️ Desativa a integração de validação e de envio de produtos para o ElevenTickets Access. Utilizar essa opção somente se a validação dos itens ocorrer totalmente via ElevenTickets Access.",
  }),
  computed: {
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      return false;
    },
    isCommomOrCourtesy() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo ===
          "INGRESSO" ||
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "CORTESIA"
      );
    },
    isVoucherProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "VOUCHER"
      );
    },
    storeHasElevenTicketsAccessInfo() {
      const elevenTicketsInfo = JSON.parse(
        localStorage.getItem("eleventickets_access")
      );

      if (
        elevenTicketsInfo?.token_circus !== null &&
        elevenTicketsInfo?.url_circus !== null &&
        this.isAdmin
      ) {
        return true;
      }

      return false;
    },
    hasCircusValidation() {
      return (
        this.$produtos_gerenciar.cadastro.regra_acesso.valida_circus &&
        this.isAdmin
      );
    },
  },
};
</script>

<style scoped></style>
